import React, { Component } from 'react';
import { Form, InputGroup, Navbar, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { Link } from 'react-router-dom';
import loader from '../../imgs/ajax-loader.gif';
import logoBi from '../../logo-bi.png';
import $ from 'jquery';
import { udfSetRuleHistorySearchKeyword } from '../../common/usr/stdtList';
import { dropByCacheKey } from 'react-router-cache-route'
import { udfAutoLogin, AlertModal, openAlert } from '../../common/common';

class UsrMainCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      usrInfo: null,
    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    const that = this;
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data });
        if (!data.AUTH_CFM_DATE && !localStorage.SCHOOL_AUTH_EMAIL_POP) {
          openAlert(that, '** 이메일 인증 등록 안내 **\n\n이메일 인증을 사용하면 비밀번호를 분실하거나 도난당한 경우에도 계정을 더 안전하게 보호 할 수 있습니다.\n\n[비밀번호 변경 및 이메일 인증 등록] 사이드 메뉴에서 이메일 인증 등록을 확인해 주세요. (선택사항)');
          localStorage.setItem('SCHOOL_AUTH_EMAIL_POP', 'Y');
        }
      } else {
        this.props.history.push('/');
      }
    });
  }

  componentWillMount = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');
    dropByCacheKey('noticeSchoolCachce');
  }

  render() {
    return (
      <div className="container App-header">
        <AlertModal
          show={this.state.alertShow}
          onHide={this.alertClose}
          Title="스쿨라이프"
          Message={this.state.alertMessage}
          onClickOk={this.state.alertClickOk}
          onClickNo={this.state.alertClickNo}
          onClickYes={this.state.alertClickYes}
        />
        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          HOME
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
          />
        </Navbar>

        <Row style={{ width: '100%' }}>
          <Col>
            <Form className="text-center" onSubmit={() => { $('#searchKeywordLabel').click(); }}>
              <img src={logoBi} alt="스쿨라이프" style={{ height: "15vh", marginBottom: '1rem' }} />
              <InputGroup>
                <Form.Control
                  className="form-control-lg"
                  type='text'
                  id='searchKeyword'
                  placeholder='검색(학번 / 이름)'
                  onChange={(e) => { udfSetRuleHistorySearchKeyword(e.target.value) }}
                />
                <Link to='/usr/ruleHistory'>
                  <InputGroup.Append style={{ height: '48px' }}>
                    <InputGroup.Text
                      id="searchKeywordLabel"
                      style={{ fontSize: '1.5rem' }}
                      className="pl-4 pr-4"
                    >
                      <FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                  </InputGroup.Append>
                </Link>
              </InputGroup>
              <p className="mt-3">
                학번 5자리 (학년1자리+반2자리+번호2자리)<br /> 또는 학생이름으로 검색해 주세요.
                <br />
                (예: 1학년 2반 15번 검색시 10215 입력)
              </p>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UsrMainCmp;